import React, { Component } from 'react';
import './Header.css'

class Header extends Component {
    render() {
        return (
            <section class="category_banner">
                <div class="container">
                    <div class="row">
                        <div class="col-md-8 category_bannertext">
                            <h3>our clients</h3>
                            <p>We bring to bear boundless intellectual energy and commercially actionable insights in every engagement with our clients. Our expertise and leading research in unexplored markets are trusted by 300+ brands across the globe.</p>
                        </div>
                    </div>
                </div>
            </section>
        );
    }


}


export default Header;


// WEBPACK FOOTER //
// ./src/clients/header/header.js